<template>
  <div id="box">
    <div class="head">
      <div class="imgbox">
        <img src="~@/common/img/about_resume.png">
      </div>
      <div class="channel clearfix">
        <div class="fl list">
          <div class="line"></div>
          <div class="circle">1</div>
          <div class="circle">2</div>
          <div class="circle">3</div>
        </div>
        <div class="fl channelinfo">
          <div>
            <p>通过Email将个人完整简历直接发送至公司招聘邮箱</p>
            <div class="hremail">HR@ecaray.com</div>
          </div>
          <div>
            <div>或者通过以下网站输入公司全称『
              <span class="company">深圳市前海亿车科技有限公司</span> 』 即可投递简历</div>
            <div class="clearfix innerbox">
              <div class="fl">
                <a href="http://company.zhaopin.com/CC292726782.html" target="_blank">
                  <img src="~@/common/img/zl.png"></a>
                <div>
                  <a href="http://company.zhaopin.com/CC292726782.html" target="_blank">智联招聘：www.zhaopin.com</a>
                </div>
              </div>
              <div class="fl">
                <a href="http://jobs.51job.com/all/co3685887.html" target="_blank">
                  <img src="~@/common/img/wy.png"></a>
                <div>
                  <a href="http://jobs.51job.com/all/co3685887.html" target="_blank">前程无忧：www.51job.com</a>
                </div>
              </div>
              <div class="fl">
                <a href="http://www.lagou.com/gongsi/j7232.html" target="_blank">
                  <img src="~@/common/img/lg.png"></a>
                <div>
                  <a href="http://www.lagou.com/gongsi/j7232.html" target="_blank">拉勾网：www.lagou.com</a>
                </div>
              </div>
              <!-- <div class="fl">
                <img src="~@/common/img/58.png">
                <div>
                  <a href="http://qy.58.com/37616003496208/574/pn1?PGTID=0d411266-0180-772e-aaa4-bdfba65b9ca9&ClickID=1" target="_blank">58同城：sz.58.com</a>
                </div>
              </div> -->
            </div>
          </div>
          <div>
            <p>联系招聘人：祝小姐</p>
            <div class="hremail">0755-86638522</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title">招聘岗位</div>
      <div class="content">
        <div v-for="(item,index) in type_list" :key="index" class="typebox" :class="[item.id == pid ? 'boxshade' : '']" v-if="arr[index] != 0">
          <div class="clearfix">
            <div class="fl typename">{{item.name}}</div>
            <div class="fl clearfix joblist">
              <Thejob :jid='pids' @child="_length" @throw="_set" :id="item.id"></Thejob>
            </div>
            <div class="fr">
              <img src="~@/common/img/about_arrow_down.png" @click="_change($event)" data-act='down' :data-id="item.id">
            </div>
          </div>
          <div class="typeinfo" v-html="mono" v-if="item.id == pid"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Thejob from './children/job';
import { getJobTypeList, getJobList } from '@/api/portal';
export default {
  components: {
    Thejob,
  },
  data() {
    return {
      type_list: [], //岗位类别
      arr: [],
      mono: '',
      pid: '',
      pids: '',
    };
  },
  methods: {
    //获取岗位类别
    _gettype() {
      getJobTypeList({ action: 'recruit.jobType.getJobTypeList' })
        .then(res => {
          this.type_list = res.data;
        })
        .catch(err => {});
    },
    //获取工作
    _getjob(id) {
      getJobList({ action: 'recruit.job.getJobList', type_id: id, name: '' })
        .then(res => {
          this.mono = res.data[0].meno;
          this.pids = res.data[0].id;
          this.pid = res.data[0].type_id;
        })
        .catch(err => {});
    },
    _set(val) {
      this.mono = val.meno;
      this.pid = val.type_id;
    },
    _length(val) {
      this.arr.push(val);
    },
    _change(event) {
      var target = event.target;
      var id = target.getAttribute('data-id');
      if (target.getAttribute('data-act') == 'down') {
        var src = require('@/common/img/about_arrow_up.png');
        target.setAttribute('src', src);
        target.setAttribute('data-act', 'up');
        //展开
        this._getjob(id);
      } else {
        var src = require('@/common/img/about_arrow_down.png');
        target.setAttribute('src', src);
        target.setAttribute('data-act', 'down');
        this.pid = '';
        this.pids = '';
      }
    },
  },
  created() {
    this._gettype();
  },
};
</script>


<style scoped>
@import '../news/detail/quill.core.scss';
@import '../news/detail/quill.snow.scss';
@import '../news/detail/quill.bubble.scss';
@import '../news/detail/quill-edit.config.scss';
#box {
  width: 1121px;
  margin: 0 auto;
}
.imgbox {
  text-align: center;
}
.fl {
  float: left;
}
.fr {
  float: right;
  margin-top: 8px;
}
.clearfix:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}
.channel {
  width: 1000px;
  margin: 0 auto;
  color: #888;
  font-size: 15px;
}
.circle {
  background-image: url('~@/common/img/about_title_bg.png');
  background-repeat: no-repeat;
  background-position: center center;
  text-align: center;
  line-height: 40px;
  width: 90px;
  height: 40px;
  position: relative;
  z-index: 2;
}
.list {
  position: relative;
}
.list > div:nth-child(n + 3) {
  margin-top: 96px;
}
.line {
  content: '';
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #eaeaea;
  left: 50%;
  top: 0;
  z-index: 1;
}
.channel a {
  color: #333;
  cursor: pointer;
}
.channel a:hover {
  text-decoration: none;
  color: #ff6600;
}
.channel > div:last-child {
  margin-left: 40px;
  margin-top: -14px;
}
.hremail {
  font-size: 24px;
  color: #000;
}
.channelinfo > div:nth-child(2) {
  margin-top: 62px;
}
.channelinfo > div:nth-child(3) {
  margin-top: 56px;
}
.company {
  color: #333;
}
.innerbox {
  margin-top: 16px;
}
.innerbox > div {
  text-align: center;
}
.innerbox > div:not(:first-child) {
  margin-left: 32px;
}
.title {
  font-size: 28px;
  color: #000;
  text-align: center;
  margin-top: 96px;
}
.content {
  margin-top: 32px;
  padding-bottom: 96px;
}
.content > div:nth-child(n + 2) {
  margin-top: 24px;
}
.typebox {
  border: 1px #dadada solid;
  border-radius: 8px;
  padding: 24px;
}
.typename {
  color: #303030;
  font-size: 18px;
  line-height: 32px;
}
.joblist {
  margin-left: 72px;
  width: 930px;
}
.typeinfo {
  width: 768px;
  margin: 0 auto;
  padding: 32px 0 0;
  font-size: 14px;
}
.boxshade {
  box-shadow: 2px 2px 12px #eaeaea, -2px -2px 12px #eaeaea;
}
</style>
